import { render, staticRenderFns } from "./TargetGroups.vue?vue&type=template&id=67f3249e&scoped=true&"
import script from "./TargetGroups.vue?vue&type=script&lang=js&"
export * from "./TargetGroups.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroups.vue?vue&type=style&index=0&id=67f3249e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f3249e",
  null
  
)

export default component.exports